import React, {
    useState,
    useEffect
} from "react";
import * as Icon from "react-bootstrap-icons";
import { ThreeCircles } from "react-loader-spinner";
const RefreshButton = ({refreshflag, refreshfunction}) => {
    const [refresh, setRefresh] = useState(refreshflag)
    useEffect(() => {
        setRefresh(refreshflag)
    }, [refreshflag])

    return (
        refresh ?
            <div style={{ marginLeft: 20, marginTop: 5, float: "right" }}>
                <ThreeCircles
                    height="20"
                    width="20"
                    color="#4fa94d"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                    ariaLabel="three-circles-rotating"
                    outerCircleColor="var(--theme1_tertiary)"
                    innerCircleColor="var(--theme1_secondary)"
                    middleCircleColor="var(--theme1_primary)"
                />
            </div>
            :
            <Icon.ArrowCounterclockwise onClick={() => refreshfunction()}
                style={{
                    fontSize: 20,
                    float: "right",
                    border: "0px",
                    marginLeft: 20,
                    marginTop: 5,
                    cursor: "pointer"
                }} />
    )
}

export default RefreshButton;